import React from "react";

// `pop` opts into the pronounced card-pop hover (see index.css). It is OFF by
// default on purpose: Panel is also the dashboard's table and form container,
// and scaling a full-width data table on hover looks like a glitch rather than
// an affordance. Pass pop only where the Panel is genuinely a card in a grid.
const Panel = ({ as: Tag = "div", padded = false, pop = false, tone = "default", className = "", children, ...props }) => {
  const toneCls = tone === "soft" ? "bg-[var(--panel-2)]" : "bg-[var(--panel)]";
  return (
    <Tag
      className={[
        toneCls,
        "border border-[var(--line)] rounded-[var(--r)]",
        // Flat-bordered at rest, lift on hover. `pop` swaps the restrained
        // 1px nudge for the full rise-and-scale.
        pop ? "card-pop" : "transition-all duration-200 hover:shadow-[var(--shadow)] hover:-translate-y-[1px]",
        padded ? "p-[24px]" : "",
        className,
      ].join(" ")}
      {...props}
    >
      {children}
    </Tag>
  );
};

export default Panel;
